import React, { useState, useEffect } from "react";

const EditUserModal = ({ user, open, onClose, onSave }) => {
  const [form, setForm] = useState({ name: '', email: '', role: '', password: '' });
  const [error, setError] = useState(null);

  useEffect(() => {
    if (user) setForm({ name: user.name, email: user.email, role: user.role, password: '' });
  }, [user]);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  if (!open) return null;

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (error) setError(null);
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!form.name || !form.email || !form.role) {
      setError("Name, email, and role are required.");
      return;
    }
    if (!validateEmail(form.email)) {
      setError("Invalid email address.");
      return;
    }
    if (form.password && form.password.length < 6) {
      setError("Password must be at least 6 characters long.");
      return;
    }
    onSave({ ...user, ...form });
  }

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000
    }}>
      <form
        onSubmit={handleSubmit}
        style={{ background: '#fff', padding: 24, borderRadius: 8, minWidth: 320 }}
      >
        <h3>Edit User</h3>
        { error && (
          <div style={{ color: 'red', marginBottom: 10 }}>
            {error}
          </div>
        )}
        <input
          name="name"
          value={form.name}
          onChange={handleChange}
          style={{ margin: '8px 0', width: '100%', padding: 8 }}
          placeholder="Name"
        />
        <input
          name="email"
          value={form.email}
          onChange={handleChange}
          style={{ margin: '8px 0', width: '100%', padding: 8 }}
          placeholder="Email"
        />
        <input
          name="password"
          value={form.password || ''}
          onChange={handleChange}
          style={{ margin: '8px 0', width: '100%', padding: 8 }}
          placeholder="New Password (optional)"
          type="password"
        />
        <select
          name="role"
          value={form.role}
          onChange={handleChange}
          style={{ margin: '8px 0', width: '100%', padding: 8 }}
        >
          <option value="">Select role</option>
          <option value="user">User</option>
          <option value="admin">Admin</option>
        </select>
        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button type="button" style={{ cursor: "pointer" }} onClick={onClose}>Cancel</button>
          <button type="submit" style={{ cursor: "pointer", background: '#007bff', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: 4 }}>Save</button>
        </div>
      </form>
    </div>
  );
};

export default EditUserModal;
